import ColorPicker from './ColorPicker';

class FavoriteList {
    constructor() {
        this.ajaxLock = false;
        this.$ = jQuery;
        this.init();
    }

    init() {
        this.events();
    }

    fetchFavoriteList() {
        const self = this;

        let elem = document.getElementById('my-favorites-list')

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_fav_get_list_shortcode',
            },
        }).done(function (response) {
            self.ajaxLock = false;
            console.log(response)
            elem.innerHTML = response?.html || "fav"
            self.favListActions();
        })
    }

    loadFavoriteButton() {
        const self = this;

        let elem = document.getElementById('single-favorites');

        if(typeof elem === null) return;

        let postId = Array.from(document.body.classList).find(e => e.includes('postid-'))?.split("-")[1] ?? null;
        if(!postId) return;

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_fav_short_code',
                id: postId,
            },
        }).done(function (response) {
            self.ajaxLock = false;
            elem.innerHTML = response?.html || ""
            self.addToCartOrFavListSP();
        })
    }
    
    /**
     * Add products to favorite list
     * 
     */
    ajaxAddToFavList(nonce, id) {
        let self = this;
        this.ajaxLock = true;

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_add_to_fav_list',
                nonce: nonce,
                id: id,
            },
        })
            .done(function (response) {
                self.ajaxLock = false;

                window.location.reload(true);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                self.ajaxLock = false;

                console.log(XMLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);

                self.$("#product-picker-fav").removeClass("loading")
            })
    }

    /**
     * Method responsible for adding products to the cart or the fav list
     * 
     */
    addToCartOrFavList() {
        let self = this;

        // Add to cart:

        // Add to favorite list:
        this.$('.color-info #color-picker-fav').each(function () {
            self.$(this).on('click', function () {
                let id = self.$(this).data('id');
                let nonce = self.$(this).data('nonce');

                self.ajaxAddToFavList(nonce, id);
            });
        });
    }
        
     /**
     * Method responsible for adding products to the fav list (single product)
     * 
     */
    addToCartOrFavListSP() {
    let self = this;

    // Add to cart:

    // Add to favorite list:
    this.$('#product-picker-fav').on('click', function () {
            let id = self.$(this).data('id');
            let nonce = self.$(this).data('nonce');

            self.$(this).addClass('loading')

            self.ajaxAddToFavList(nonce, id);
        });
    }

    /**
     * Method responsible for events
     * 
     */
    events() {
        let self = this;

        this.addToCartOrFavList();
        this.addToCartOrFavListSP();
        this.loadFavoriteButton();

        this.$( '.mm__header_menu_wrapper .menu-icons .fav' ).on( 'click', function( e ) {
            e.preventDefault();

            self.fetchFavoriteList();

            if ( !self.$( '#site-header #fav-list' ).hasClass( 'is-active' ) ) {
                self.$( '#site-header #fav-list' ).addClass( 'is-active' );

                if ( !self.$( '#dark-bg' ).hasClass( 'is-active' ) ) {
                    self.$( '#dark-bg' ).addClass( 'is-active' );
                }
            }
        });

        this.$( '#site-header #fav-list .fav-list-head svg' ).on( 'click', function() {
            if ( self.$( '#site-header #fav-list' ).hasClass( 'is-active' ) ) {
                self.$( '#site-header #fav-list' ).removeClass( 'is-active' );
                
                // Trigger only on mobile devices
                if ( 576 > self.$( window ).width() ) {
                    self.$( '#site-header #fav-list' ).fadeOut( 100 );
                } else {
                    if ( self.$( '#dark-bg').hasClass( 'is-active' ) ) {
                        self.$( '#dark-bg').removeClass( 'is-active' );
                    }
                }
            }
        });

        self.favListActions();
    }

    favListActions() {
        let self = this;
        this.ajaxLock = true;
        
        this.$( '#fav-list .remove-fav' ).each(function() {
            self.$( this ).on( 'click', function( e ) {
                e.preventDefault();

                const IDS = [];
                let nonce = self.$( this ).data( 'nonce' );

                IDS.push( self.$( this ).data( 'id' ) );

                // Only trigger if there are products to be removed
                if ( 1 <= IDS.length ) {
                    self.ajaxRemoveFromFavoriteList( JSON.stringify( IDS ), nonce );
                }
            });
        });

        this.$( '#fav-list .remove-all' ).on( 'click', function() {
            const IDS = [];
            let nonce = self.$( this ).data( 'nonce' );

            self.$( '#fav-list .remove-fav' ).each(function() {
                IDS.push( self.$( this ).data( 'id' ) );
            });

            // Only trigger if there are products to be removed
            if ( 1 <= IDS.length ) {
                self.ajaxRemoveFromFavoriteList( JSON.stringify( IDS ), nonce );
            }
        });
    }

    /**
     * Remove products from favorite list
     * 
     * @param {*} jsonObj 
     * @param {*} nonce 
     */
    ajaxRemoveFromFavoriteList(jsonObj, nonce) {
        let self = this;
        this.ajaxLock = true;

        this.$.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'mm_remove_from_fav_list',
                jsonObj: jsonObj,
                nonce: nonce,
            },
        })
        .done(function( response ) {
            self.ajaxLock = false;

            console.log( response.status );
            window.location.reload( true );
        })
        .fail(function( jqXHR, textStatus, errorThrown ) {
			self.ajaxLock = false;

			console.log( XMLHttpRequest );
			console.log( textStatus );
			console.log( errorThrown );
        });
    }
}

export default FavoriteList;